const welcomePage = {
  "welcome.header": "Eleva tu juego",
  "welcome.subheader": "Mejora tu rendimiento futbolístico con análisis, métricas y mucho más desde tu dispositivo.",
};

export const welcome = {
  ...welcomePage,
};
